<template>
  <Fragment>
    <el-popover
      class="popover z-10"
      :class="{ invisible: Object.keys(time).length === 0 }"
      placement="bottom-end"
      trigger="hover"
      popper-class="pop_content"
    >
      <svg-icon slot="reference" iconName="info-circle-icon" className="tooltip-icon" />
      <div class="process-time-container">
        <div v-if="time.deposit" v-html="$t('processTime.depositProcessTime', { time: time.deposit })"></div>
        <div v-if="time.withdraw" v-html="$t('processTime.withdrawProcessTime', { time: time.withdraw })"></div>
        <div v-if="time.bank" v-html="$t('processTime.bankProcessTime', { time: time.bank })"></div>
        <div v-if="time.psp" v-html="$t('processTime.pspProcessTime', { time: time.psp })"></div>
      </div>
    </el-popover>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
  components: {
    Fragment
  },
  props: {
    time: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.invisible {
  visibility: hidden;
}

.el-popover {
  .process-time-container > div {
    text-align: start;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}

.popover {
  @include rtl-sass-prop(margin-left, margin-right, 10px);
}
</style>
